import { Action } from '@ngrx/store';
import { User } from '../_models/user.model';

export enum AuthActionTypes {
  Login = '[Auth] Login',
  Reload = '[Auth] Reload',
  Logout = '[Auth] Logout',
  UserRequested = '[Auth] Request User',
  UserLoaded = '[Auth] Load User',
  SetQvTokens = '[Auth] Set Qv Token',
  SetTwixorToken = '[Auth] Set Twixor Token',
  RequestQvTokens = '[Auth] Request Qv Token',
  ResetPassword = '[Auth] Password changed',
  RefreshAccessToken = '[Auth] Refresh Access Token',
  RequestPassword = '[Auth] RequestPassword',
  AuthActionToggleLoading = '[Auth] Action Toggle Loading',
  ThrowError = '[Auth] ThrowError',
  ClearErrors = '[Auth] ClearErrors',
  ImpersonationRoles = '[Impersonation] Set User Roles',
  OriginalUserRoles = '[Impersonation] Get Original User Roles',
  ReloadDashboard = '[Impersonation] Reload Dashboard',
}

export class Login implements Action {
  readonly type = AuthActionTypes.Login;
  constructor(public payload: { authToken: string }) {}
}
export class Reload implements Action {
  readonly type = AuthActionTypes.Reload;
  constructor(public payload: { authToken: string; userInfo: User }) {}
}

export class Logout implements Action {
  readonly type = AuthActionTypes.Logout;
  constructor(
    public saveURL: boolean = true,
    public payload: { onSignout?: boolean; fromBroadCast?: boolean } = {},
  ) {}
}

export class UserRequested implements Action {
  readonly type = AuthActionTypes.UserRequested;
}

export class UserLoaded implements Action {
  readonly type = AuthActionTypes.UserLoaded;
  constructor(public payload: { user: User }) {}
}

export class RequestQvTokens implements Action {
  readonly type = AuthActionTypes.RequestQvTokens;
  constructor(public payload: { userId: string; appId: string }) {}
}

export class SetQvTokens implements Action {
  readonly type = AuthActionTypes.SetQvTokens;
  constructor(public payload: { qv_token: string }) {}
}

export class SetTwixorToken implements Action {
  readonly type = AuthActionTypes.SetTwixorToken;
  constructor(public payload: { twixor_token: string }) {}
}

export class RefreshAccessToken implements Action {
  readonly type = AuthActionTypes.RefreshAccessToken;
  constructor(public payload: { accessToken: string }) {}
}

export class RequestPassword implements Action {
  readonly type = AuthActionTypes.RequestPassword;
  constructor(public payload: { email: string }) {}
}

export class AuthPageToggleLoading implements Action {
  readonly type = AuthActionTypes.AuthActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class AuthActionToggleLoading implements Action {
  readonly type = AuthActionTypes.AuthActionToggleLoading;
  constructor(public payload: { isLoading: boolean }) {}
}

export class ThrowError implements Action {
  readonly type = AuthActionTypes.ThrowError;

  constructor(public payload: { error: any }) {}
}
export class ImpersonationRoles implements Action {
  readonly type = AuthActionTypes.ImpersonationRoles;
  constructor(public payload: { impersonationUser: any }) {}
}
export class ReloadDashboard implements Action {
  readonly type = AuthActionTypes.ReloadDashboard;
}
export class OriginalUserRoles implements Action {
  readonly type = AuthActionTypes.OriginalUserRoles;
}

export class ClearErrors implements Action {
  readonly type = AuthActionTypes.ClearErrors;
}
export type AuthActions =
  | Login
  | Reload
  | Logout
  | UserRequested
  | UserLoaded
  | RequestQvTokens
  | SetQvTokens
  | SetTwixorToken
  | RefreshAccessToken
  | RequestPassword
  | AuthPageToggleLoading
  | AuthActionToggleLoading
  | ClearErrors
  | ThrowError
  | ImpersonationRoles
  | OriginalUserRoles;
